<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Įgaliojimų / prokūrų atliktos paieškos') }}</h1>

    <!-- search -->
    <performed-searches-search :loading="loading" @search="doSearch" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->

      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import PerformedSearchesSearch from './PerformedSearchesSearch'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'

export default {
  name: 'PerformedSearches',
  components: {
    PerformedSearchesSearch
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    headers() {
      return [
        {
          text: this.$t('Paieškos numeris'),
          align: 'center',
          sortable: true,
          value: 'id',
        },
        {
          text: this.$t('Paieškos pavadinimas'),
          align: 'center',
          sortable: true,
          value: 'search_type',
        },
        {
          text: this.$t('Paieškos data ir laikas'),
          align: 'start',
          sortable: true,
          value: 'created_at',
        },
        {
          text: this.$t('Paieškos kriterijai'),
          align: 'start',
          sortable: true,
          value: 'criterias',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    clearSelectedItem() {
        this.selectedItem = null
    },
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`performed-searches/list`, data)
        .then((res) => {
          this.listData = res.data.performedSearches
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    viewInModaltem(item){
      this.$axios
        .get(`jar-failed-jobs/${item.id}`).then((res) => {
          this.selectedItem = res.data.jarFailedJob
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        this.showModal = true
    },
    confirmInModaltem(item){
      this.selectedItem = item;
      this.showConfirmModal = true
      this.confirmModalTitle = 'UUID: ' + item.uuid
      this.confirmModalText = "Ar tikrai norite grąžinti užduotį į eilę pakartotiniam atlikimui?"
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    doSearch(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
